import { ITimeSlot } from "../interfaces/i-time-slot";
import { TimeSlotType } from "./time-slot-type";

export class SelectedSlotTime implements ITimeSlot {

    constructor(type = null){
        this.type = type
    }

    type: TimeSlotType;
    id: number;
    startDate: string;
    endDate: string;
    isChecked : boolean = false;
}
